module.exports = __webpack_public_path__ + "img/coupon_rule.7a79008f.jpg";